import { AttestationForRequest, AttestationOption } from '@sdk/automatedBreaks/types/Attestation';

export enum AttestationItemStep {
  first = 0,
  second = 1
}

export type Attestation = AttestationForRequest & { id: string; step: AttestationItemStep };

export type UpdateAttestationOptionPayload = {
  attestIndex: number;
  option: AttestationOption;
};
export type UpdateAttestationStepPayload = {
  attestIndex: number;
  step: AttestationItemStep;
};
export type UpdateAttestationTextPayload = {
  attestIndex: number;
  text: string;
};
